module.exports = __webpack_public_path__ + "img/lock-open-fill.0bf2565a.svg";